import axios from "axios";

export const getApplicantProfiles = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_applicant_profiles"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
